export const chartDays = [
  {
    label: "24 Hours",
    value: 1,
  },
  {
    label: "2 Days",
    value: 2,
  },
  {
    label: "3 Days",
    value: 3,
  },
  {
    label: "4 Days",
    value: 4,
  },
  {
    label: "5 Days",
    value: 5,
  },
  {
    label: "6 Days",
    value: 6,
  },
  {
    label: "7 Days",
    value: 7,
  },
  {
    label: "30 Days",
    value: 30,
  },
  {
    label: "3 Months",
    value: 90,
  },
  {
    label: "1 Year",
    value: 365,
  },
];
